"use client"

import { useTheme } from "./theme-provider"
import Image from "next/image"

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme()

  return (
    <>
    <div className="light-toggle" onClick={toggleTheme}>
      <div className={`c-block-d ${theme === "light" ? "c-block-d--active" : ""}`}>
      <Image 
            src="/webflow-assets/images/sun-ml.svg" 
            width={10}
            height={0}
            style={{height: "auto"}}
            loading="lazy" 
            alt="Light mode"
            className="img-erdd"/>
        <Image 
            src="/webflow-assets/images/sun-md.svg" 
            width={10}
            height={0}
            style={{height: "auto"}}
            loading="lazy" 
            alt="Light mode"
            className="img-erdd"/>
      </div>
      <div className={`c-block-d ${theme === "dark" ? "c-block-d--active" : ""}`}>
        <Image 
            src="/webflow-assets/images/moon-ml.svg" 
            loading="lazy" 
            width={10}
            height={0}
            style={{height: "auto"}}
            alt="Dark mode"
            className="img-erdd"/>
        <Image 
            src="/webflow-assets/images/moon-md.svg" 
            loading="lazy" 
            width={10}
            height={0}
            style={{height: "auto"}}
            alt="Dark mode" 
            className="img-erdd"/>
      </div>
    </div>
    </>
    
  )
}
